var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUtilize(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 178,
    viewBox: "0 0 123 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M61.9473 116.588V51.2344",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.0059 137.055L19.0059 97.3555",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M103.732 137.062V108.352",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_3013_3359",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.0947 171.497V175.688L53.1267 171.497H53.0947Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.0947 171.497V170.497H52.0947V171.497H53.0947ZM53.0947 175.688H52.0947L54.0947 175.695L53.0947 175.688ZM53.1267 171.497L54.1267 171.505L54.1344 170.497H53.1267V171.497ZM52.0947 171.497V175.688H54.0947V171.497H52.0947ZM54.0947 175.695L54.1267 171.505L52.1267 171.489L52.0948 175.68L54.0947 175.695ZM53.1267 170.497H53.0947V172.497H53.1267V170.497Z",
    fill: "#0F1936",
    mask: "url(#path-4-inside-1_3013_3359)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M28.0797 135.909C28.8949 134.31 30.0458 132.742 31.5803 131.287L26.4493 128.328C26.4493 128.328 26.4174 128.312 26.4014 128.296V136.629H26.8329L28.0637 135.909H28.0797Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M93.9342 135.91C93.119 134.31 91.9681 132.743 90.4336 131.288L95.6125 128.297C95.6125 128.297 96.3318 127.609 96.3478 127.593V136.918H94.4297L93.9502 135.926L93.9342 135.91Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M38.1337 161.501C37.6861 161.757 37.0947 161.885 36.4873 161.917V172.49C37.0787 172.474 37.6701 172.346 38.1337 172.074L43.2647 169.099V158.526L38.1337 161.501Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M73.6025 144.818C74.6575 145.426 75.5366 146.098 76.2719 146.818C80.3799 142.867 79.5008 137.669 73.6025 134.262C66.6493 130.247 55.3643 130.247 48.4111 134.262C42.5128 137.669 41.6337 142.867 45.7417 146.818C46.477 146.114 47.3561 145.426 48.4111 144.818C55.3643 140.804 66.6493 140.804 73.6025 144.818Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M53.0947 161.309V165.131L53.1267 161.325H53.0947V161.309Z",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M96.332 166.283V166.412C96.332 166.412 96.332 166.315 96.332 166.283Z",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M83.929 161.517L78.75 158.526V169.099L83.929 172.09C84.4085 172.362 85.0319 172.506 85.6553 172.506V161.933C85.0319 161.933 84.4085 161.789 83.929 161.517Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M66.49 166.427L54.9493 166.395C53.5746 166.395 53.0791 165.916 53.0951 165.132V171.514H53.1271L53.0951 175.704C53.0951 176.504 53.5746 176.968 54.9493 176.968L66.49 177C67.8647 177 68.9836 176.36 68.9996 175.576V165.004C68.9996 165.804 67.8647 166.443 66.49 166.427Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M96.332 155.727V155.855C96.332 155.855 96.332 155.759 96.332 155.727Z",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M34.6014 161.517L28.0797 157.758L26.4333 156.798C26.4333 156.798 26.4174 156.798 26.4014 156.782V167.355C26.4014 167.355 26.4174 167.355 26.4333 167.371L34.6014 172.073C35.1129 172.377 35.8002 172.505 36.4875 172.473V161.9C35.8162 161.916 35.1289 161.789 34.6014 161.501V161.517Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M53.0941 165.132V161.309C52.3268 161.086 45.5175 159.31 43.2637 158.526V169.099C46.1728 170.106 49.8812 171.034 53.0941 171.498V165.116V165.132Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M69.0154 161.277L68.9834 164.988V175.561L69.0154 171.402C72.4041 170.938 75.6809 170.17 78.7499 169.099V158.526C76.4002 159.342 69.8306 161.038 69.0154 161.277Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M68.9834 165.004L69.0154 161.293C69.0154 161.293 68.9994 161.293 68.9834 161.293V165.004Z",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M95.6124 156.798L95.2607 157.006H96.3317V155.854C96.2997 156.206 96.0759 156.542 95.6124 156.798Z",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M95.2615 157.007L93.9189 157.791L87.4612 161.517C86.9656 161.805 86.3103 161.933 85.6709 161.933V172.506C86.3263 172.506 86.9656 172.378 87.4612 172.09L95.6132 167.371C96.0767 167.115 96.3005 166.763 96.3325 166.428V157.023H95.2615V157.007Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M101.591 146.466H98.3619L94.3018 146.434C94.2379 146.562 94.1739 146.69 94.11 146.818C93.2948 148.545 92.08 150.209 90.4336 151.776L93.8383 153.743L95.6125 154.767C96.0761 155.023 96.2999 155.375 96.3318 155.711C96.3318 155.759 96.3318 155.807 96.3318 155.839V156.99H101.607C101.719 157.006 101.83 156.99 101.926 156.99C102.694 156.926 103.349 156.686 103.733 156.318V145.746C103.285 146.162 102.502 146.45 101.591 146.434V146.466Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M27.9029 146.802C27.807 146.595 27.6791 146.371 27.5992 146.163H23.8109L20.3103 146.131C19.639 146.131 19.0315 145.971 18.584 145.715V156.287C18.8877 156.463 19.2873 156.559 19.7029 156.639C19.8947 156.671 20.1025 156.719 20.3103 156.719L26.4004 156.751V154.816C26.4004 154.816 26.4163 154.816 26.4323 154.8L28.6382 153.52L31.5793 151.809C29.9329 150.241 28.7181 148.562 27.9029 146.834V146.802Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M101.703 136.917H96.3162L95.6768 136.885H94.43C94.2862 136.533 94.1103 136.198 93.9345 135.862C93.1033 134.246 91.9364 132.695 90.4019 131.223L95.5329 128.248C96.508 127.688 96.508 126.777 95.5329 126.217L87.3649 121.515C86.3899 120.955 84.8234 120.955 83.8483 121.515L78.7014 124.506C75.7762 123.482 72.6433 122.746 69.4144 122.282L69.4464 118.044C69.4464 117.244 68.3435 116.604 66.9688 116.604L55.4281 116.572C54.0534 116.572 52.9345 117.212 52.9185 117.996L52.8705 122.25C49.5298 122.714 46.285 123.482 43.2639 124.538L38.1329 121.579C37.1579 121.019 35.5914 121.019 34.6164 121.579L26.4643 126.297C26.4643 126.297 26.4323 126.313 26.4163 126.329V128.296C26.4163 128.296 26.4483 128.312 26.4643 128.328L31.5953 131.287C30.0608 132.759 28.9099 134.31 28.0947 135.91C27.9668 136.15 27.839 136.389 27.7271 136.629H26.8479H26.4163L20.4382 136.597C19.7029 136.597 19.0475 136.773 18.584 137.061V145.714C19.0315 145.97 19.639 146.13 20.3103 146.13H23.8109L27.5992 146.162C27.6951 146.386 27.807 146.594 27.9029 146.802C28.7181 148.529 29.9329 150.209 31.5793 151.776L28.6382 153.488L26.4323 154.767C26.4323 154.767 26.4163 154.767 26.4004 154.783V156.783C26.4004 156.783 26.4163 156.783 26.4323 156.799L28.0787 157.758L34.6004 161.517C35.1119 161.821 35.7992 161.949 36.4865 161.917C37.0779 161.901 37.6694 161.773 38.1329 161.501L43.2639 158.526C45.5177 159.31 52.3271 161.085 53.0943 161.309C53.0943 161.309 53.1103 161.309 53.1263 161.309L53.0943 165.116C53.0943 165.915 53.5739 166.379 54.9485 166.379L66.4893 166.411C67.8639 166.411 68.9828 165.771 68.9988 164.988V161.277C68.9988 161.277 69.0148 161.277 69.0308 161.277C69.846 161.037 76.4156 159.342 78.7653 158.526L83.9442 161.517C84.4238 161.789 85.0472 161.933 85.6706 161.933C86.3259 161.933 86.9653 161.805 87.4608 161.517L93.9185 157.79L95.2612 157.006L95.6129 156.799C96.0764 156.543 96.3002 156.191 96.3322 155.855V155.727C96.3002 155.375 96.0764 155.039 95.6129 154.783L93.8386 153.76L90.4339 151.792C92.0803 150.225 93.2951 148.545 94.1103 146.834C94.1743 146.706 94.2542 146.578 94.3021 146.45H98.3622L101.591 146.482C102.502 146.482 103.285 146.21 103.733 145.794V137.573C103.285 137.205 102.55 136.965 101.703 136.949V136.917ZM76.2717 146.802C75.5364 147.506 74.6573 148.193 73.6023 148.801C66.6491 152.816 55.3641 152.816 48.4109 148.801C47.3559 148.193 46.4768 147.522 45.7415 146.802C41.6335 142.851 42.5126 137.653 48.4109 134.246C55.3641 130.232 66.6491 130.232 73.6023 134.246C79.5006 137.653 80.3797 142.851 76.2717 146.802Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M7.154 102.961L11.8534 101.889L18.6468 104.512L19.9255 88.9656L39.3946 77.7214C41.3766 76.5858 42.5914 74.4745 42.5914 72.1873L47.3548 54.1775L40.1618 50.0509C39.4745 49.651 38.6113 49.651 37.924 50.0509L4.19688 69.5482C2.21482 70.6838 1 72.7951 1 75.0823V97.7945C1 98.4343 1.31969 99.0261 1.84717 99.394L7.154 102.961Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M9.48765 103.265L17.9114 98.4024V103.681C17.9114 104.544 19.0463 104.864 19.4939 104.112L25.504 94.0039L44.973 82.7598C46.9551 81.6242 48.1699 79.5129 48.1699 77.2257V55.761C48.1699 54.2735 46.5555 53.3299 45.2608 54.0816L9.75938 74.5866C7.77732 75.7222 6.5625 77.8335 6.5625 80.1207V101.585C6.5625 103.073 8.17693 104.017 9.47166 103.265H9.48765Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M32.8401 80.9841L22.8818 86.7421V75.242L32.8401 69.5V80.9841Z",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M73.8395 54.2098L69.14 53.1382L62.3467 55.7613L61.0679 40.2146L41.5989 28.9704C39.6168 27.8348 38.402 25.7235 38.402 23.4363L33.6387 5.42648L40.8317 1.2999C41.519 0.900034 42.3821 0.900034 43.0695 1.2999L76.8126 20.7972C78.7946 21.9328 80.0094 24.0441 80.0094 26.3313V49.0436C80.0094 49.6833 79.6898 50.2751 79.1623 50.643L73.8555 54.2098H73.8395Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M71.5211 54.4982L63.0974 49.6358V54.914C63.0974 55.7777 61.9625 56.0976 61.5149 55.3459L55.5048 45.2373L36.0357 33.9932C34.0537 32.8576 32.8389 30.7463 32.8389 28.4591V6.99442C32.8389 5.50693 34.4533 4.56325 35.748 5.315L71.2494 25.82C73.2315 26.9556 74.4463 29.0669 74.4463 31.3541V52.8187C74.4463 54.3062 72.8319 55.2499 71.5371 54.4982H71.5211Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M46.3311 27.3551C46.3311 28.9865 46.6348 30.2021 47.1942 31.3697C47.7217 32.4893 48.441 33.481 49.3521 34.3127C50.2472 35.1284 51.2383 35.7362 52.4211 36.0081C53.4921 36.264 54.547 36.2001 55.5381 35.6562C56.4012 35.1924 57.0086 34.4727 57.4083 33.593C57.8079 32.6973 57.9517 31.7536 57.9198 30.7779C57.8238 28.8266 57.1205 27.0832 55.9377 25.5477C55.1385 24.5241 54.1794 23.7083 52.9966 23.1485C52.2293 22.7967 51.4141 22.5727 50.5669 22.6207C48.9205 22.6847 47.7217 23.4844 46.9544 24.9399C46.5069 25.8036 46.3311 26.7313 46.3311 27.3551Z",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M115.481 114.174L110.782 113.102L103.988 115.725L102.71 100.178L83.2405 88.9343C81.2584 87.7987 80.0436 85.6874 80.0436 83.4002L75.2803 65.3903L82.4733 61.2638C83.1606 60.8639 84.0237 60.8639 84.7111 61.2638L118.454 80.7611C120.436 81.8967 121.651 84.008 121.651 86.2952V109.007C121.651 109.647 121.331 110.239 120.804 110.607L115.497 114.174H115.481Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M113.146 114.461L104.722 109.599V114.877C104.722 115.741 103.587 116.061 103.14 115.309L97.1298 105.2L77.6607 93.9561C75.6787 92.8205 74.4639 90.7092 74.4639 88.422V66.9573C74.4639 65.4698 76.0783 64.5261 77.373 65.2779L112.874 85.7829C114.856 86.9185 116.071 89.0298 116.071 91.317V112.782C116.071 114.269 114.457 115.213 113.162 114.461H113.146Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M99.304 100.051L88.1309 93.5888L94.189 80.6973L99.304 100.051Z",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilize);
export default __webpack_public_path__ + "static/media/utilize.49be0982654be15efe02236fe14362c0.svg";
export { ForwardRef as ReactComponent };